import classNames from "classnames";
import { useEffect, useState } from "react";
import { DEFAULT_EVENT_IMAGE_URL } from "../../utils/constants";
import { getEventPosterSrc } from "./eventPosterImage";

export const EventImage = ({
  image,
  className = "",
  dimension = 200,
  fixedSize = false,
}: {
  image?: File | string;
  className?: string;
  dimension?: number;
  fixedSize?: boolean;
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [image]);

  const imageSource = imageFailed
    ? DEFAULT_EVENT_IMAGE_URL
    : image || DEFAULT_EVENT_IMAGE_URL;
  const imageSrc =
    typeof imageSource === "string"
      ? getEventPosterSrc(imageSource)
      : URL.createObjectURL(imageSource);

  return (
    <div
      className={classNames(
        "relative overflow-hidden rounded-[14px] bg-grey-50",
        fixedSize ? "shrink-0" : "w-full pt-[100%] md:pt-0",
        {
          "md:h-[158px] md:max-h-[158px] md:min-w-[158px] md:max-w-[158px]":
            dimension === 158,
          "md:h-[200px] md:max-h-[200px] md:min-w-[200px] md:max-w-[200px]":
            dimension === 200,
          "md:h-[300px] md:max-h-[300px] md:min-w-[300px] md:max-w-[300px]":
            dimension === 300,
          "md:h-[400px] md:max-h-[400px] md:min-w-[400px] md:max-w-[400px]":
            dimension === 400,
          "md:h-[472px] md:max-h-[472px] md:min-w-[472px] md:max-w-[472px]":
            dimension === 472,
          "h-[100px] max-h-[100px] w-[100px] max-w-[100px]":
            fixedSize && dimension === 100,
        },
        className,
      )}
    >
      <img
        className="absolute inset-0 h-full w-full object-cover"
        src={imageSrc}
        alt="event poster"
        onError={() => {
          if (imageSrc !== DEFAULT_EVENT_IMAGE_URL) {
            setImageFailed(true);
          }
        }}
      />
    </div>
  );
};
